import { render, staticRenderFns } from "./OrgList.vue?vue&type=template&id=50502d3a&scoped=true&"
import script from "./OrgList.vue?vue&type=script&lang=js&"
export * from "./OrgList.vue?vue&type=script&lang=js&"
import style0 from "./OrgList.vue?vue&type=style&index=0&id=50502d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50502d3a",
  null
  
)

export default component.exports